import { render } from "./ProductDetailPage.vue?vue&type=template&id=fb26eb1c"
import script from "./ProductDetailPage.vue?vue&type=script&lang=js"
export * from "./ProductDetailPage.vue?vue&type=script&lang=js"

import "./ProductDetailPage.vue?vue&type=style&index=0&id=fb26eb1c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__